import { appStateSelectors } from "../../../modules/appState";
import { displayCacheSelectors } from "../../../modules/display";

const getSelectedDisplayItems = state => {
  const displayItems = displayCacheSelectors.getDisplayItemsById(state);
  const selectedIds = appStateSelectors.getSelectedItems(state);
  return selectedIds.map(id => displayItems.get(id));
};

export default getSelectedDisplayItems;
